import React, {Component, useEffect, useState} from "react";
import {AuthProvider, useAuth} from "./AuthContext";
import ProtectedRoute from "./ProtectedRoute";

import {socket, requestData} from "./socket"
import { BUILD_ID } from "./const";

import {
    BrowserRouter as Router,
    useRoutes,
} from "react-router-dom";

import MainFrame from "./components/page-elements/main-frame"

import Page404 from "./components/page-elements/page-404"

import LogIN from "./components/page-elements/page-login"
import Register from "./components/page-elements/page-register"
import InviteAccept from "./components/page-elements/page-invite-accept"
import ForgotPassword from "./components/page-elements/page-forgot-password"
import TwoFa from "./components/page-elements/page-two-fa"
import ChooseWorkspace from "./components/page-elements/page-choose-workspace"

import Profile from "./components/tables/old/profile"
import Dashboard from "./components/tables/dashboard"


import AppContext from "./app-context"

import Servers from "./components/tables/servers";
import WebSites from "./components/tables/web_sites";
import CustomTest from "./components/tables/custom_test";
import Wordpress from "./components/tables/wordpress";
import Domains from "./components/tables/domains";
import Certificates from "./components/tables/certificates";
import BrokenLinks from "./components/tables/broken_links";
import StatusPage from "./components/tables/status_page";
import Contacts from "./components/tables/contacts";
import Users from "./components/tables/users";
import Workspaces from "./components/tables/workspaces";
import Invoices from "./components/tables/invoices";
import ChangeHistory from "./components/tables/change-history";
import Tickets from "./components/tables/tickets";

import ServerDashboard from "./components/tables/server-dashboard";
import WebSiteDashboard from "./components/tables/website-dashboard";
import PushTestsDashboard from "./components/tables/pushtests-dashboard";
import WordPressDashboard from "./components/tables/wordpress-dashboard";
import BrokenLinksDashboard from "./components/tables/brokenlist-dashboard";
import LoadSpeed from "./components/tables/load-speed";
import CertificatesDashboard from "./components/tables/certificates-dashboard";
import DomainsDashboard from "./components/tables/domains-dashboard";
import ChooseDashboard from "./components/tables/choose-dashboard";

console.info(`[App] build id: ${BUILD_ID}`);

// Устанавливаем язык из query (?lang=en) до инициализации приложения
const applyLangFromQuery = () => {
    try {
        const params = new URLSearchParams(window.location.search);
        const lang = params.get("lang");
        if (lang) {
            localStorage.setItem("lang", lang.toLowerCase());
        }
    } catch (e) {
        console.warn("[App] unable to parse lang from query", e);
    }
};
applyLangFromQuery();

const AppRoutes = (props) => {
    let routes = useRoutes([
        // Dashboard and Authentication
        { path: "/", element: <ProtectedRoute><LogIN /></ProtectedRoute> },
        { path: "/sign-in", element: <LogIN /> },
        { path: "/sign-up", element: <Register /> },
        { path: "/forgot-password", element: <ForgotPassword /> },
        { path: "/invite/accept/:token", element: <InviteAccept /> },
        { path: "/validate-two-fa", element: <TwoFa /> },
        { path: "/choose-workspace", element: <ChooseWorkspace /> },

        /*{ path: "/", element: <ProtectedRoute><MainFrame><Dashboard /></MainFrame></ProtectedRoute> },*/
        { path: "/dashboard", element: <ProtectedRoute><MainFrame><Dashboard /></MainFrame></ProtectedRoute> },


        // Profile
        { path: "/my-profile/:tab", element: <ProtectedRoute><MainFrame><Profile /></MainFrame></ProtectedRoute> },

        { path: "/choose-dashboard/:object", element: <ProtectedRoute><MainFrame><ChooseDashboard /></MainFrame></ProtectedRoute> },

        // Servers and Related Entities
        { path: "/servers", element: <ProtectedRoute><MainFrame><Servers /></MainFrame></ProtectedRoute> },
        {path: "/server/:id/:page", element: <ProtectedRoute><MainFrame><ServerDashboard /></MainFrame></ProtectedRoute>},

        // Websites
        { path: "/web-sites", element: <ProtectedRoute><MainFrame><WebSites /></MainFrame></ProtectedRoute> },
        { path: "/web-site/:id/:page", element: <ProtectedRoute><MainFrame><WebSiteDashboard /></MainFrame></ProtectedRoute> },

        // Push Tests
        { path: "/push-tests", element: <ProtectedRoute><MainFrame><CustomTest /></MainFrame></ProtectedRoute> },
        { path: "/push-test/:id/:page", element: <ProtectedRoute><MainFrame><PushTestsDashboard /></MainFrame></ProtectedRoute> },

        // WordPress
        { path: "/wordpress", element: <ProtectedRoute><MainFrame><Wordpress /></MainFrame></ProtectedRoute> },
        { path: "/wordpress/:id/:page", element: <ProtectedRoute><MainFrame><WordPressDashboard /></MainFrame></ProtectedRoute> },

        // Domains and Certificates
        { path: "/domains", element: <ProtectedRoute><MainFrame><Domains /></MainFrame></ProtectedRoute> },
        { path: "/domains/:id/:page", element: <ProtectedRoute><MainFrame><DomainsDashboard /></MainFrame></ProtectedRoute> },

        { path: "/certificates", element: <ProtectedRoute><MainFrame><Certificates /></MainFrame></ProtectedRoute> },
        { path: "/certificates/:id/:page", element: <ProtectedRoute><MainFrame><CertificatesDashboard /></MainFrame></ProtectedRoute> },

        // Broken Links
        { path: "/broken-links", element: <ProtectedRoute><MainFrame><BrokenLinks /></MainFrame></ProtectedRoute> },
        { path: "/broken-link/:id/:page", element: <ProtectedRoute><MainFrame><BrokenLinksDashboard /></MainFrame></ProtectedRoute> },

        { path: "/load-speed", element: <ProtectedRoute><MainFrame><LoadSpeed /></MainFrame></ProtectedRoute> },

        // Status Pages
        { path: "/status-pages", element: <ProtectedRoute><MainFrame><StatusPage /></MainFrame></ProtectedRoute> },

        // Contacts and Payments
        { path: "/contacts-group", element: <ProtectedRoute><MainFrame><Contacts /></MainFrame></ProtectedRoute> },
        { path: "/invoices", element: <ProtectedRoute><MainFrame><Invoices /></MainFrame></ProtectedRoute> },

        { path: "/users", element: <ProtectedRoute><MainFrame><Users /></MainFrame></ProtectedRoute> },
        { path: "/workspaces", element: <ProtectedRoute><MainFrame><Workspaces /></MainFrame></ProtectedRoute> },
        { path: "/history", element: <ProtectedRoute><MainFrame><ChangeHistory /></MainFrame></ProtectedRoute> },
        { path: "/tickets", element: <ProtectedRoute><MainFrame><Tickets /></MainFrame></ProtectedRoute> },

        // Catch-all for 404
        { path: "*", element: <Page404 /> },
    ]);
    return routes;
};

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            seconds: 0,
            isActive: false,
            site_id: 0,
        };

        //AppContext.user.id = "1"
        //AppContext.user.name = "Artem Z"
        //AppContext.user.role = "SEO"
        //AppContext.user.email = "artem.z@avega-group.com"

        this.setState = this.setState.bind(this);
    }


    updateState(key, data) {
        var info = {}
        info[key] = data

        this.setState((prvState) => ({
            ...prvState,
            ...info,
        }));

        console.log(" ::: update state ::: ", info)
    }

    startListerners(listObject = []){
        listObject.forEach((object) => {

            const action = object.fn || 'List'
            this.updateState(`${object.name}${action}`, [])

            let fn = "list"
            if(object.fn && object.fn != "") fn = object.fn

            const noListener = object.noListener || false

            if(noListener == false) {
                socket.on(`${object.name}:${fn}-data`, (data) => {
                    this.updateState(`${object.name}${action}`, data)
                });
            }

            const { user } = useAuth();
            requestData(user, object.name, object.args || {}, fn);

            if( object.interval &&  object.interval > 999 ){
                setInterval(() => {
                    requestData(user, object.name, object.args || {}, fn);
                }, object.interval);
            }
        })
    }

    componentDidMount() {
        //console.log("Ddd");
        if (!this.state.isActive) {

            const listObject = [
                //{name:"customersMessages", fn: "MessagesByCustomerList"},
                //{name:"customersRequests",},
            ]

            this.startListerners(listObject)
        }

        socket.on(`token-expired`, (data) => {
            localStorage.removeItem("authToken");
            localStorage.removeItem("companyId");
            window.location.replace(`/sign-in`);
        });
    }

    getSeconds = (s) => {
        return `0${this.state.seconds % 60}`.slice(-2);
    };

    getMinutes = (s) => {
        return Math.floor(this.state.seconds / 60);
    };

    render() {
        return (
            <AuthProvider>
                <Router>
                    <AppRoutes state={this.state} setState={this.setState.bind(this)} />
                </Router>
            </AuthProvider>
        );
    }
}

export default App;
